module.exports = __webpack_public_path__ + "img/rw5.a0537806.webp";